module.exports = __webpack_public_path__ + "img/ico-plus-dark.76530ca1.svg";